import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function ExitPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('exit_popup_dismissed');
    if (dismissed) return;

    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        setShow(true);
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave);
    }, 5000);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  const handleClose = () => {
    setShow(false);
    sessionStorage.setItem('exit_popup_dismissed', 'true');
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-60" data-testid="exit-popup">
      <div className="bg-white max-w-md w-full mx-4 relative" style={{ border: '3px solid black' }}>
        <button onClick={handleClose} className="absolute top-3 right-3 text-gray-400 hover:text-black" data-testid="exit-popup-close">
          <X className="w-5 h-5" />
        </button>

        <div className="bg-black text-white text-center py-6 px-8">
          <h2 className="text-2xl font-bold tracking-wide" style={{ fontFamily: 'Playfair Display' }}>
            No te vayas sin tu descuento
          </h2>
        </div>

        <div className="p-8 text-center">
          <p className="text-gray-600 mb-4">
            Usa este código en tu primer pedido superior a 80€ en productos Arthur Fitz
          </p>

          <div className="border-2 border-dashed border-black px-6 py-3 mb-4 inline-block">
            <span className="text-2xl font-bold tracking-widest" data-testid="exit-popup-code">PRIMERPEDIDO</span>
          </div>

          <p className="text-xl font-bold mb-6">5% de descuento</p>

          <Button
            onClick={handleClose}
            className="w-full bg-black text-white hover:bg-gray-800 py-4 text-base"
            data-testid="exit-popup-cta"
          >
            SEGUIR COMPRANDO
          </Button>

          <p className="text-xs text-gray-400 mt-4">Envío 100% discreto en todos los pedidos</p>
        </div>
      </div>
    </div>
  );
}
